// extracted by mini-css-extract-plugin
export default {"klarnaContainer":"klarna-container_klarnaContainer__10831","showKlarna":"klarna-container_showKlarna__944c9"};